import reduceReducers from 'reduce-reducers';

import createUserReducer from 'app/modules/user/actions/createUser';
import updateUserReducer from 'app/modules/user/actions/updateUser';
import initialState from 'app/modules/user/initialState';

export default reduceReducers(updateUserReducer, createUserReducer);

/*
 * selectors
 */

export const getId = state => {
  return state.id;
};

export const getUserId = state => {
  return state.userId;
};

export const getGladlyCustomerId = state => {
  return state.gladlyCustomerId;
};

export const getName = state => {
  return state.name;
};

export const getEmail = state => {
  return state.email;
};

export { initialState };
